import { ContractorDetail, ContractorIndividualList, ContractorLegalList } from '../../pages';

export const routingContractor = [
  {
    path: '/contractorIndividual',
    exact: true,
    component: ContractorIndividualList,
    claims: ['CanLookContragentSection'],
  },
  {
    path: '/contractorLegal',
    exact: true,
    component: ContractorLegalList,
    claims: ['CanLookContragentSection'],
  },
  {
    path: '/contractor-detail/:id',
    exact: true,
    component: ContractorDetail,
    claims: ['CanLookContragentSection'],
  },
];
